import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../reducer';

const useGlobalKeyListener = () => {
    const user = useSelector((state: RootState) => state.user);
    const storeRef = useRef(user); // Use a ref to store the latest state
  
    useEffect(() => {
      storeRef.current = user; // Update ref whenever the store changes
    }, [user]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
        const isToolRegisteruser = storeRef.current?.me?.user_clearence_groups?.includes("Tool Register") || false;

        if(isToolRegisteruser){
            if (event.key === 'F9') {
              window.location.href = '/#/tool-register?value=0';
            } else if (event.key === 'F10') {
              window.location.href = '/#/tool-register?value=1';
            }
        }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

export default useGlobalKeyListener;